module.exports = __webpack_public_path__ + "img/inovatorio.b36dd188.svg";